import React, { useState, useEffect } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import DataGrid from '../components/DataGrid';
import { Accordion } from 'react-bootstrap';
import IconButton from '@material-ui/core/IconButton';
import EditIcon from '@material-ui/icons/Edit';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import Swal from 'sweetalert2'
import { formatDate } from '../common/util';
import { DESERVE_STATUS, DESERVE_STATUS_STRING_VALUE, APPROVED_STATUS, APPROVED_STATUS_LABELS } from "../components/constants";

const serverUrl = process.env.REACT_APP_SERVER_URL;

const Deserves = () => {
  const [deserves, setDeserves] = useState([]);
  const [products, setProducts] = useState([]);
  const [users, setUsers] = useState([]);
  const [vouchers, setVouchers] = useState([]);
  const { getAccessTokenSilently } = useAuth0();

  useEffect(() => {
    async function getDeserves() {
      const token = await getAccessTokenSilently();
      localStorage.setItem("AcccessToken", token);
      const response = await fetch(`${serverUrl}/api/admin/deserves`, {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });
      const deservesData = await response.json();
      setDeserves(deservesData);
    }
    async function getProducts() {
      const token = await getAccessTokenSilently();
      localStorage.setItem("AcccessToken", token);
      const response = await fetch(`${serverUrl}/api/admin/products`, {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });
      const productsData = await response.json();
      setProducts(productsData);
    }
    async function getUsers() {
      const token = await getAccessTokenSilently();
      localStorage.setItem("AcccessToken", token);
      const response = await fetch(`${serverUrl}/api/admin/users`, {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });
      const usersData = await response.json();
      setUsers(usersData);
    }
    async function getVouchers() {
      const token = await getAccessTokenSilently();
      localStorage.setItem("AcccessToken", token);
      const response = await fetch(`${serverUrl}/api/admin/vouchers`, {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });
      const usersData = await response.json();
      setVouchers(usersData);
    }

    getDeserves();
    getProducts();
    getUsers();
    getVouchers();
  }, [getAccessTokenSilently, serverUrl]);

  return (
    <div className="container">
      <h1>Administration</h1>
      <p>Auf dieser Seite findest Du alle Objekte!</p>
      <Accordion>
        <Accordion.Item eventKey="0">
          <Accordion.Header>So funktioniert's</Accordion.Header>
          <Accordion.Body>
            <strong>deserves: Status 2 "deserved" muss geprüft und auf "Akzeptiert vom Admin" oder "Abgelehnt vom Admin" umgestellt werden</strong><br />
            {Object.entries(DESERVE_STATUS)
              .filter(([key, value]) => value !== 0) // skip 0
              .map(([key, value]) => (
                <div key={value}>
                  {value}: "{DESERVE_STATUS_STRING_VALUE[key]}"
                </div>
              ))}
            <br />
            <strong>Produkte: Status "Ausstehend" muss geprüft und genehmigt oder abgelehnt werden</strong><br />
            Solange der Admin die Änderung nicht genehmigt hat, bleibt das Produkt in der Produktübersicht unverändert. Bei Anpassungen durch den Admin, ist im Kommentarfeld immer ein Kommentar zu erfassen. Dieser kann anschliessend vom Company User gelesen werden.<br />
            <br />
            <strong>User: Diese Ansicht dient einzig dazu, eine Übersicht über die User zu erlangen</strong><br />
            <br />
            <strong>Gutscheine: Diese Ansicht dient dazu, eine Übersicht über die Gutscheine zu erlangen</strong><br />
            Im Notfall kann ein fälschlicherweise eingelöster gutscheind vom Admin wieder geöffnet und auf "Gültig" gestellt werden. Verwende dazu den Button auf der jeweiligen Zeile.<br />

          </Accordion.Body>
        </Accordion.Item>
        <Accordion.Item eventKey="1">
          <Accordion.Header>deserves</Accordion.Header>
          <Accordion.Body>
            <DataGrid
              title='Liste aller deserves'
              columns={columnsDeserves}
              data={deserves || []}
              options={{
                filtering: true,
                sorting: true,
                exportButton: true,
                pageSize: 10,
              }}
            />
          </Accordion.Body>
        </Accordion.Item>
        <Accordion.Item eventKey="2">
          <Accordion.Header>Produkte</Accordion.Header>
          <Accordion.Body>
            <DataGrid
              title='Liste aller Produkte'
              columns={columnsProducts}
              data={products || []}
              options={{
                filtering: true,
                sorting: true,
                exportButton: true,
                pageSize: 10,
              }}
            />
          </Accordion.Body>
        </Accordion.Item>
        <Accordion.Item eventKey="3">
          <Accordion.Header>User</Accordion.Header>
          <Accordion.Body>
            <DataGrid
              title='Liste aller User'
              columns={columnsUsers}
              data={users || []}
              options={{
                filtering: true,
                sorting: true,
                exportButton: true,
                pageSize: 10,
              }}
            />
          </Accordion.Body>
        </Accordion.Item>
        <Accordion.Item eventKey="4">
          <Accordion.Header>Gutscheine</Accordion.Header>
          <Accordion.Body>
            <DataGrid
              title='Liste aller Gutscheine'
              columns={columnsVouchers}
              data={vouchers || []}
              options={{
                filtering: true,
                sorting: true,
                exportButton: true,
                pageSize: 10,
              }}
            />
          </Accordion.Body>
        </Accordion.Item>
      </Accordion>
    </div>
  );
};

const statusLookup = Object.entries(DESERVE_STATUS)
  .filter(([key, value]) => value !== 0) // skip 0
  .reduce((acc, [key, value]) => {
    acc[value] = DESERVE_STATUS_STRING_VALUE[key];
    return acc;
  }, {});

const columnsDeserves = [
  {
    title: '',
    field: '',
    sorting: false,
    filtering: false,
    render: rowData => (
      <IconButton
        color="primary"
        onClick={() =>
          //window.open(`/adminEdit/${rowData.idProduct}`, '_blank') // ✅ open in new window
          window.location.href = `/adminDeserveEdit/${rowData.idProduct}/${rowData.userId}` // ✅ open in same window
        }
      >
        <EditIcon />
      </IconButton>
    )
  },
  { field: 'deserveId', title: 'deserve ID' },
  {
    field: 'status',
    title: 'Status',
    lookup: statusLookup,
  },
  { field: 'idProduct', title: 'Produkt ID' },
  { field: 'companyName', title: 'Name des Unternehmens' },
  { field: 'price', title: 'Benötigte Likes' },
  {
    field: 'expirationDate',
    title: 'deserve Zeit bis',
    render: rowData => formatDate(rowData.expirationDate),
  },
  { field: 'userId', title: 'User ID' },
  { field: 'userEmail', title: 'User Email' },
  // { field: 'companyId', title: 'Company ID' },
  // { field: 'companyEmail', title: 'Company Email' },
  {
    field: 'postUrl',
    title: 'Post URL',
    cellStyle: {
      maxWidth: 200,
      //whiteSpace: 'nowrap',
      //overflow: 'hidden',
      //textOverflow: 'ellipsis'
    },
    headerStyle: {
      maxWidth: 200
    },
    render: rowData => rowData.postUrl ? decodeURIComponent(rowData.postUrl) : ''
  },
];

const columnsProducts = [
  {
    title: '',
    field: '',
    sorting: false,
    filtering: false,
    render: rowData => (
      <IconButton
        color="primary"
        onClick={() =>
          //window.open(`/adminEdit/${rowData.idProduct}`, '_blank') // ✅ open in new window
          window.location.href = `/adminProductEdit/${rowData.idProduct}` // ✅ open in same window
        }
      >
        <EditIcon />
      </IconButton>
    )
  },
  { field: 'idProduct', title: 'Produkt ID' },
  {
    field: 'approvedStatus', title: 'Status',
    lookup: Object.fromEntries(
      Object.entries(APPROVED_STATUS_LABELS).filter(
        ([key]) => Number(key) !== APPROVED_STATUS.APPROVED_PAST
      )
    ),
    render: rowData => {
      return APPROVED_STATUS_LABELS[rowData.approvedStatus] || "";
    }

  },
  {
    field: 'categoryId',
    title: 'Produktkategorie',
    lookup: {
      1: "Restaurantbesuch",
      2: "Produkt",
    },
  },
  { field: 'idUser', title: 'User ID' },
  { field: 'name', title: 'Produktname' },
  { field: 'companyName', title: 'Name des Unternehmens' },
  {
    field: 'timeperiodeFrom',
    title: 'Startdatum',
    render: rowData => formatDate(rowData.timeperiodeFrom),
  },
  {
    field: 'timeperiodeTo',
    title: 'Enddatum',
    render: rowData => formatDate(rowData.timeperiodeTo),
  },
  { field: 'price', title: 'Benötigte Likes' },
  { field: 'quantity', title: 'Anzahl Stücke' },
];

const columnsUsers = [
  {
    title: "",
    field: "",
    sorting: false,
    filtering: false,
    render: (rowData) =>
      rowData.company === 1 ? ( // ⬅️ Only show when company = 1
        <IconButton
          color="primary"
          onClick={
            () =>
              //window.open(``, '_blank') // ✅ open in new window
              (window.location.href = `/adminUserEdit/${rowData.id}`) // ✅ open in same window
          }
        >
          <EditIcon />
        </IconButton>
      ) : null,
  },
  { field: "id", title: "User ID" },
  { field: "email", title: "User Email" },
  {
    field: "company",
    title: "Company?",
    lookup: {
      0: "Nein",
      1: "Ja",
    },
    filtering: true
  },
  { field: "companyName", title: "Name des Unternehmens" },
  { field: "createdts", title: "Erstellt am" },
  { field: "updatedts", title: "Bearbeitet am" },
];

const columnsVouchers = [
  { field: 'idProduct', title: 'Produkt ID' },
  { field: 'idUser', title: 'User ID' },
  {
    field: 'voucherCode',
    title: 'Gutscheinnummer',
    render: rowData => (
      <a
        href={`/voucher/${rowData.voucherCode}`}
        target="_blank"
        rel="noopener noreferrer"
      >
        {rowData.voucherCode}
      </a>
    )
  },
  { field: 'verificationCode', title: 'Prüfnummer' },
  {
    field: 'usedByUser',
    title: 'Eingelöst von User ID',
    render: rowData => rowData.usedByUser ? rowData.usedByUser : ''
  },
  {
    field: 'usedOn',
    title: 'Verwendet am',
    render: rowData => formatDate(rowData.usedOn),
  },
  {
    title: 'Gutschein auf "Gültig" zurückstellen',
    field: '',
    sorting: false,
    filtering: false,
    render: rowData => (
      <IconButton
        color="primary"
        onClick={() => {
          Swal.fire({
            title: 'Achtung!',
            text: 'Bist Du sicher, dass Du den Gutschein wieder auf "Gültig" zurückstellen möchtest?',
            icon: 'warning',
            showCancelButton: true, // Zeigt den "Abbrechen"-Button
            confirmButtonText: 'Ja',
            cancelButtonText: 'Nein',
            customClass: {
              confirmButton: "btn btn-outline-warning",
              cancelButton: "btn btn-outline-warning"
            },
            buttonsStyling: false
          }).then((result) => {
            if (result.isConfirmed) {
              reopenVoucher(rowData.voucherCode)
            }
          });
        }}
      >
        <ArrowBackIcon />
      </IconButton>
    )
  },
];

const reopenVoucher = async (voucherCode) => {
  try {
    const token = localStorage.getItem("AcccessToken");
    const response = await fetch(`${serverUrl}/api/admin/voucherReopen/${voucherCode}`, {
      method: "PUT",
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });

    const result = await response.json();

    // Popup anzeigen
    Swal.fire({
      title: result.isSuccessful ? "Erfolg!" : "Fehler!",
      text: result.message || (result.isSuccessful ? "Gutschein wurde wieder geöffnet." : "Etwas ist schiefgelaufen."),
      icon: result.isSuccessful ? "success" : "error",
      confirmButtonText: "OK",
      customClass: {
        confirmButton: "btn btn-outline-warning"
      },
      buttonsStyling: false
    }).then(() => {
      window.location.reload(); // Seite neu laden
    });

  } catch (err) {
    // Fehler beim Request
    Swal.fire({
      title: "Fehler!",
      text: err.message || "Etwas ist schiefgelaufen.",
      icon: "error",
      confirmButtonText: "OK",
      customClass: {
        confirmButton: "btn btn-outline-warning"
      },
      buttonsStyling: false
    });
  }
};

export default Deserves;